<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Confirm Order</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="dialog = false"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-300px scroll-y mx-5 mx-xl-15 py-7"
      >
        <!--begin::Body-->

        <form id="createForm" class="pa-3 pb-0">
          <v-text-field
            v-model.trim="$v.formData.confirm_order_field.$model"
            :error-messages="
              validateState('confirm_order_field') ? errorMessages : ''
            "
            label="Confirm Order Field"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-text-field
            v-model.trim="$v.formData.confirm_order_value.$model"
            :error-messages="
              validateState('confirm_order_value') ? errorMessages : ''
            "
            label="Confirm Order Value"
            clearable
            dense
            outlined
          ></v-text-field>
        </form>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Apiservice from "@/core/services/api.service";

export default {
  mixins: [validationMixin],
  validations: {
    formData: {
      confirm_order_field: { required },
      confirm_order_value: { required },
    },
  },
  name: "ConfirmOrder",
  props: ["loader", "integration_id"],
  data: () => ({
    dialog: false,
    formData: {
      confirm_order_field: null,
      confirm_order_value: null,
    },
    errorMessages: ["This Field is required"],
    flagData: null,
  }),
  methods: {
    toggleModal() {
      this.getOrderPrefix();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formData[name];
      return $dirty ? $error : null;
    },
    getOrderPrefix() {
      this.loader(true);
      let data = {
        integration_id: this.integration_id,
      };
      Apiservice.post("/validations/confirmedOrders", data)
        .then((response) => {
          this.flagData = response.data;
          this.resetData();
          this.loader(false);
          this.dialog = true;
        })
        .catch(() => {
          this.loader(false);
        });
    },
    submitCreateForm() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return;
      }
      this.loader(true);
      let data = { ...this.formData, integration_id: this.integration_id };
      Apiservice.post("/validations/confirmedOrders/update", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "The Confirm Order has been updated",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.dialog = false;
          this.loader(false);
        })
        .catch(() => {
          this.loader(false);
        });
    },
    resetData() {
      this.formData = {
        confirm_order_field: this.flagData.confirm_order_field,
        confirm_order_value: this.flagData.confirm_order_value,
      };
    },
  },
};
</script>
